define('shared/initializer/form/newHouseAdapters/Redemption',[ 
    '../constants', 
    './Checkout', 
    'shared/lib/ctor', 
    'shared/lib/RSVP',
    'shared/lib/URI',
    'shared/util/checkout/RedemptionCodeHelper',
    'shared/remote/redemption/validate'
], 
function ( 
    constants, 
    Checkout, 
    ctor, 
    RSVP, 
    URI,
    RedemptionCode,
    validateRedemptionCode
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);
    }).inherit(Checkout); 

    var p = Ctor.prototype;

    function createError(type, message, fatal){
        var err = new Error(message);
        err.type = type;
        err.fatal = fatal;
        return err;
    }

    p.doPageLoad = function() {
        var me = this;
        var basePromise;

        if (!me.redemptionCode) {
            me.redemptionCode = new RedemptionCode(me.options.useRedemptionCode);
        }

        if (Checkout.prototype.doPageLoad == null) {
            basePromise = RSVP.resolve();
        }
        else {
            basePromise = Checkout.prototype.doPageLoad.apply(me, arguments);
        }

        return basePromise
            .then(function(){
                return me.redemptionCode.retrieve();
            })
            .then(function(rCode){
                var redemptionCodeField = me.items.get(constants.FIELD.redemptionCode);
                redemptionCodeField.$el.val(rCode);
            });
    };

    p.doSubmit = function() {
        var me = this;
        var redemptionCodeField = me.items.get(constants.FIELD.redemptionCode);
        var redemptionCode = redemptionCodeField.$el.val();

        return validateRedemptionCode({
            redemptionCode: redemptionCode
        }).then(null, function(){
            return false;
        });
    };

    p.doAfterPageLoad = function() {
        var me = this;
        var basePromise;

        if ( Checkout.prototype.doAfterPageLoad == null ) {
            basePromise = RSVP.resolve();
        }
        else {
            basePromise = Checkout.prototype.doAfterPageLoad.apply(me, arguments);
        }

        return basePromise.then(function(){
            var redemptionCodeField = me.items.get(constants.FIELD.redemptionCode);
            var rcode = redemptionCodeField.$el.val();
            if(rcode && rcode.length && rcode.length > 0){
                var uri = new URI( location.href );
                var query = uri.query( true );
                if(query.autosubmit !== 'false') {
                    me.$form.submit();
                }
            }
        });
    };

    p.doBeforeRedirect = function( data ){
        var me = this;
        return RSVP.resolve()
            .then(function(){
                if (!data) {
                    return RSVP.reject(createError('generic', 'Invalid redemption code', false));
                }

                var redemptionField = me.items.get(constants.FIELD.redemptionCode);

                return me.redemptionCode.persist(redemptionField.$el.val());
            })
            .then(function () {
                return data;
            });
    };

    return Ctor;
});
